import type { ValidationMessageTemplate } from '@vee-validate/i18n'
import { formatted } from '@/utils/number.helper'

interface PartialI18nDictionary {
  name?: string
  messages?: Record<string, ValidationMessageTemplate>
  names?: Record<string, string>
  fields?: Record<string, Record<string, ValidationMessageTemplate>>
}

const i18nDictionary: PartialI18nDictionary = {
  messages: {
    required: '필수 항목입니다.',
    email: '유효하지 않은 이메일입니다.',
    min: (ctx) => `최소 ${ctx.rule?.params}자 이상 입력해 주세요.`,
    max: (ctx) => `최대 ${ctx.rule?.params}자 까지만 입력 가능합니다.`,
    password: '영문 + 숫자 + 특수문자 8자 이상으로 설정해 주세요.',
    phone: '정확한 휴대폰번호를 입력해 주세요.',
    numeric: '숫자만 입력해주세요.',
    is_not_extend: '비교값과 다릅니다.',
    is_not_zero: '값을 입력해주세요.',
    digits: (ctx) => `${ctx.rule?.params}자리 숫자로 입력해 주세요.`,
    yyyymmdd: 'YYYYMMDD 형식으로 입력해 주세요.',
    max_value: (ctx) => `최대값이 ${ctx.rule?.params}입니다.`,
    max_length: (ctx) =>
      `최대 ${formatted(Number(ctx.rule?.params))}장 이하로 업로드 해주세요.`,
    min_length: (ctx) =>
      `최소 ${formatted(Number(ctx.rule?.params))}장 이상 업로드 해주세요.`,
    company_number: '사업자등록번호 형식으로 입력해 주세요.',
    min_text_length: (ctx) => `최소 ${ctx.rule?.params}자 이상 입력해주세요.`,
    required_check_empty: '연관된 정보를 모두 입력해주세요.',
  },
  fields: {
    fileUploader: {
      required: '파일을 첨부해 주세요.',
    },
    imageUploader: {
      required: '사진을 등록해 주세요.',
    },
    email: {
      required: '이메일을 입력해 주세요.',
      email: '올바른 이메일 형식을 입력해 주세요.',
    },
    password: {
      required: '비밀번호를 입력해 주세요.',
    },
    passwordConfirm: {
      required: '같은 비밀번호를 입력해 주세요.',
      confirmed: '같은 비밀번호를 입력해 주세요.',
    },
    joinEmail: {
      required: '이메일을 입력해 주세요.',
      email: '올바른 이메일 형식을 입력해 주세요.',
    },
    emailVerification: {
      required: '이메일 인증이 필요합니다.',
    },
    emailVertificationCode: {
      required: '인증 번호를 입력해 주세요.',
      min: '6자리 숫자를 입력해 주세요.',
      max: '6자리 숫자를 입력해 주세요.',
    },
    emailCertification: {
      required: '이메일 인증을 완료해 주세요.',
    },
    phone: {
      required: '전화번호를 인증해 주세요.',
    },
    policy: {
      required: '필수 약관에 동의해 주세요.',
    },
    categoryId: {
      is_not_zero: '카테고리를 선택해 주세요.',
    },
    productPrice: {
      max_value: (ctx) =>
        `최대 금액 ${formatted(Number(ctx.rule?.params))}원 이하로 입력해 주세요.`,
    },
    bankAccountHolderName: {
      confirmed: '대표자 명과 같은 이름을 입력해 주세요.',
    },
    residentRegistrationNumber: {
      resident_registration_number: '주민등록번호 형식으로 입력해 주세요.',
    },
    companyRegistrationNumber: {
      corporate_registration_number: '법인등록번호 형식으로 입력해 주세요.',
    },
  },
}

export default i18nDictionary
